import List from "./List";
import Create from "./Create";
import Show from "./Show";
import Edit from "./Edit";

export const FooterLinkList = List;
export const FooterLinkCreate = Create;
export const FooterLinkShow = Show;
export const FooterLinkEdit = Edit;
